import { useBookmarks } from "./use-bookmarks";
import { useState } from "react";

export const useBookmarkToastMessage = () => {
    const { bookmarkResource, deleteBookmark, } = useBookmarks();
    const [undoBtnVisible, setUndoBtnVisible] = useState(true);
    
    const handleUndoClick = (isBookmarked: boolean, resourceId: string) => {

        if (undoBtnVisible) {
            isBookmarked
                ? deleteBookmark(resourceId)
                : bookmarkResource(resourceId);
            
            setUndoBtnVisible(false);
        }
    };

    return {
        undoBtnVisible,
        handleUndoClick,
    };
};